export function createFailure(fault) {
    return { success: false, fault };
}
export function createSuccess(value) {
    return { success: true, value };
}
export function isSuccess(operationResult) {
    return operationResult.success;
}
export function isFailure(operationResult) {
    return !isSuccess(operationResult);
}
export function ensureSuccess(operationResult) {
    if (isFailure(operationResult)) {
        throw Error(JSON.stringify(operationResult.fault));
    }
}
export function getValueOrThrow(operationResult) {
    ensureSuccess(operationResult);
    return operationResult.value;
}
